import {
  mapState,
  mapGetters,
  mapActions
} from "vuex";

export const basketBase = {
  computed: {
    ...mapState({
      items: state => state.basket.items,
      discountPercent: state => state.basket.discountPercent,
      meal_preferences: state => state.profile.meal_preferences,
      original_amount: state => state.basket.voucher.price,
      discount_amount: state => state.basket.voucher.price_with_discount,
    }),
    ...mapGetters({
      calcTotal: "basket/total"
    }),
    total: function() {
      return this.calcTotal(this.meal_preferences.people);
    }
  },
  methods: {
    ...mapActions("basket", ["removeItem", "addItem"]),
    addToBasket(item){
      this.addItem(item).then(
        (v) => {
          this.emitItemAdded(v);
        }
      );
    },
    removeFromBasket(item){
      this.removeItem(item).then(
        (v) => {
          this.emitItemRemoved(v);
        }
      )
    },
    emitItemRemoved: function(item) {
      this.$emit('itemRemoved', item);
      this.$parent.$emit('itemRemoved', item);
    },
    emitItemAdded: function(item) {
      this.$emit('itemAdded', item);
      this.$parent.$emit('itemAdded', item);
    },
      isInCart: function(item) {
      const count = this.items.reduce((a,c)=>{
        return a + (c.recipe.id==item.id ? 1 : 0)
      },0);
      return count > 0;
    }
  }
}